import {
  Labeled,
  ReferenceField,
  RichTextField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { UnixDateField } from "../UnixTimestampDateField";

const DocumentTitle = ({ record }: any) => {
  return <span>Document {record ? `"${record.title}"` : ""}</span>;
};

export const DocumentShow = (props: any) => {
  return (
    <Show {...props} title={<DocumentTitle />}>
      <SimpleShowLayout>
        <TextField source="title" />
        <TextField source="article" />
        <TextField source="rolnummer" />
        <ReferenceField reference="courts" source="court_id">
          <TextField source="content" emptyText="" />
        </ReferenceField>
        <Labeled label={"verdict_date"}>
          <UnixDateField source="verdict_date" />
        </Labeled>
        <RichTextField source="content" />
      </SimpleShowLayout>
    </Show>
  );
};
